export const isNonEmptyObject = (x: any): boolean =>
    !!x && typeof x === 'object' && !Array.isArray(x) && Object.keys(x).length > 0;

export const isCacheWorthyQuote = (q: any): boolean => {
    if (!q) { return false; }
    return isNonEmptyObject(q) && !!q.scheme && !!q.scheme.id;
};

export const mergeQuotesIntoCache = (cache: any, incomingQuotes: any): any => {
    const nextCache: any = { ...(cache || {}) };

    if (!incomingQuotes || typeof incomingQuotes !== 'object') { return nextCache; }

    Object.keys(incomingQuotes).forEach((coverLevelKey) => {
        const tripTypes = incomingQuotes[coverLevelKey];
        if (!tripTypes || typeof tripTypes !== 'object') { return; }

        const existingBucket = { ...(nextCache[coverLevelKey] || {}) };

        Object.keys(tripTypes).forEach((tripKey) => {
            const q = tripTypes[tripKey];
            if (!isCacheWorthyQuote(q)) { return; }
            existingBucket[tripKey] = q;
        });

        nextCache[coverLevelKey] = existingBucket;
    });

    return nextCache;
};

export const mergeOptionsIntoCache = (cache: any, incoming: any): any => {
    const next = { ...(cache || {}) };

    if (!incoming || typeof incoming !== 'object') { return next; }

    Object.keys(incoming).forEach((k) => {
        const v = incoming[k];
        if (typeof v === 'boolean' || k === 'hazardous_activities') {
            next[k] = v;
        }
    });

    return next;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/SchemeChoiceB/schemeChoice.cache.ts